import React from "react";
import warningIcon from "../../../../assets/pngs/studio/importMaps/warning.png";

function Warning({ closeModal,modalData }) {
  return (
    <div className="d-flex align-items-center flex-column">
      <img
        alt="delIcon"
        src={warningIcon}
        style={{
          marginRight: "1rem",
          marginLeft: "-1rem",
          marginBottom: "1rem",
        }}
      ></img>
      <h2>{modalData.header}</h2>
      <p className="import-maps-subtext pt-4">
        {modalData.subHeader}
      </p>
      <div className="row justify-content-between mt-5">
        <button
          className="col-sm cancel-btn cat-btn"
          onClick={(e) => {
            e.preventDefault();
            closeModal();
          }}
        >
          No, Cancel
        </button>
        <button
          className="col-sm del-btn cat-btn"
          style={{ marginLeft: "40px" }}
          onClick={(e) => {
            e.preventDefault();
            modalData.cb()
            closeModal()
          }}
        >
          Yes, Continue!
        </button>
      </div>
    </div>
  );
}

export default Warning;
